module.exports = __webpack_public_path__ + "welcome-3870564a17664bb0fff1731666f1202f.svg";